<!-- <app-ip-title-mobile
    [title]="'IP.CONSOLIDATED.PAID_TITLE' | translate" ></app-ip-title-mobile> -->
<app-ip-table
  [optionalTitle]="' '"
  [tableOption]="tableOptions"
  [propertyOrder]="propertyOrder"
  (action)="onAction($event)"
  [pageItems]="20"
  [filter]="false"
  service="consolidated"
  [paidOrders]="true"
  (chargeNewDate)="(changeStatus)"
  [scroll]="true"
  [searchField]="false"
></app-ip-table>
